/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { JsonObject } from '../model/json-object';
// @ts-ignore
import { PagedStorageInvoiceModel } from '../model/paged-storage-invoice-model';
// @ts-ignore
import { StorageInvoiceModel } from '../model/storage-invoice-model';
// @ts-ignore
import { StorageInvoicePaidRequestDto } from '../model/storage-invoice-paid-request-dto';
// @ts-ignore
import { StorageInvoiceRequestDto } from '../model/storage-invoice-request-dto';
// @ts-ignore
import { StorageInvoiceStatus } from '../model/storage-invoice-status';
// @ts-ignore
import { SupplierProductInfoRequestDto } from '../model/supplier-product-info-request-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class StorageInvoiceResourceService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Cancel By Supplier
     * @param invoiceId 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancelBySupplier(invoiceId: number, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public cancelBySupplier(invoiceId: number, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public cancelBySupplier(invoiceId: number, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public cancelBySupplier(invoiceId: number, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling cancelBySupplier.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/app/${this.configuration.encodeParam({name: "invoiceId", value: invoiceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/supplier-cancelled`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Cancel Storage Invoice
     * @param invoiceId 
     * @param jsonObject 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cancelStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public cancelStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public cancelStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public cancelStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling cancelStorageInvoice.');
        }
        if (jsonObject === null || jsonObject === undefined) {
            throw new Error('Required parameter jsonObject was null or undefined when calling cancelStorageInvoice.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/${this.configuration.encodeParam({name: "invoiceId", value: invoiceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/cancelled`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jsonObject,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Invoices By Supplier
     * @param storeId 
     * @param supplierId 
     * @param limit 
     * @param page 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInvoicesBySupplier(storeId: number, supplierId: number, limit?: number, page?: number, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedStorageInvoiceModel>;
    public getInvoicesBySupplier(storeId: number, supplierId: number, limit?: number, page?: number, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedStorageInvoiceModel>>;
    public getInvoicesBySupplier(storeId: number, supplierId: number, limit?: number, page?: number, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedStorageInvoiceModel>>;
    public getInvoicesBySupplier(storeId: number, supplierId: number, limit?: number, page?: number, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling getInvoicesBySupplier.');
        }
        if (supplierId === null || supplierId === undefined) {
            throw new Error('Required parameter supplierId was null or undefined when calling getInvoicesBySupplier.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>limit, 'limit');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>storeId, 'store_id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>supplierId, 'supplier_id');

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/app/suppliers`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedStorageInvoiceModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Storage Invoice By Id
     * @param invoiceId 
     * @param paymentApprovalId 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStorageInvoiceById(invoiceId: number, paymentApprovalId?: number, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<StorageInvoiceModel>;
    public getStorageInvoiceById(invoiceId: number, paymentApprovalId?: number, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<StorageInvoiceModel>>;
    public getStorageInvoiceById(invoiceId: number, paymentApprovalId?: number, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<StorageInvoiceModel>>;
    public getStorageInvoiceById(invoiceId: number, paymentApprovalId?: number, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling getStorageInvoiceById.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>paymentApprovalId, 'payment_approval_id');

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/${this.configuration.encodeParam({name: "invoiceId", value: invoiceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<StorageInvoiceModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Storage Invoices
     * @param createDateFrom 
     * @param createDateTo 
     * @param dueDateFrom 
     * @param dueDateTo 
     * @param incomingDateFrom 
     * @param incomingDateTo 
     * @param limit 
     * @param page 
     * @param paid 
     * @param paidDateFrom 
     * @param paidDateTo 
     * @param paymentApprovalId 
     * @param productInfoIds 
     * @param query 
     * @param statuses 
     * @param storeIds 
     * @param supplierId 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStorageInvoices(createDateFrom?: string, createDateTo?: string, dueDateFrom?: string, dueDateTo?: string, incomingDateFrom?: string, incomingDateTo?: string, limit?: number, page?: number, paid?: boolean, paidDateFrom?: string, paidDateTo?: string, paymentApprovalId?: number, productInfoIds?: Array<number>, query?: string, statuses?: Array<StorageInvoiceStatus>, storeIds?: Array<number>, supplierId?: number, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedStorageInvoiceModel>;
    public getStorageInvoices(createDateFrom?: string, createDateTo?: string, dueDateFrom?: string, dueDateTo?: string, incomingDateFrom?: string, incomingDateTo?: string, limit?: number, page?: number, paid?: boolean, paidDateFrom?: string, paidDateTo?: string, paymentApprovalId?: number, productInfoIds?: Array<number>, query?: string, statuses?: Array<StorageInvoiceStatus>, storeIds?: Array<number>, supplierId?: number, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedStorageInvoiceModel>>;
    public getStorageInvoices(createDateFrom?: string, createDateTo?: string, dueDateFrom?: string, dueDateTo?: string, incomingDateFrom?: string, incomingDateTo?: string, limit?: number, page?: number, paid?: boolean, paidDateFrom?: string, paidDateTo?: string, paymentApprovalId?: number, productInfoIds?: Array<number>, query?: string, statuses?: Array<StorageInvoiceStatus>, storeIds?: Array<number>, supplierId?: number, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedStorageInvoiceModel>>;
    public getStorageInvoices(createDateFrom?: string, createDateTo?: string, dueDateFrom?: string, dueDateTo?: string, incomingDateFrom?: string, incomingDateTo?: string, limit?: number, page?: number, paid?: boolean, paidDateFrom?: string, paidDateTo?: string, paymentApprovalId?: number, productInfoIds?: Array<number>, query?: string, statuses?: Array<StorageInvoiceStatus>, storeIds?: Array<number>, supplierId?: number, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createDateFrom, 'create_date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>createDateTo, 'create_date_to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dueDateFrom, 'due_date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dueDateTo, 'due_date_to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>incomingDateFrom, 'incoming_date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>incomingDateTo, 'incoming_date_to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>limit, 'limit');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>paid, 'paid');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>paidDateFrom, 'paid_date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>paidDateTo, 'paid_date_to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>paymentApprovalId, 'payment_approval_id');
        if (productInfoIds) {
            productInfoIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'product_info_ids');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>query, 'query');
        if (statuses) {
            statuses.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'statuses');
            })
        }
        if (storeIds) {
            storeIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'store_ids');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>supplierId, 'supplier_id');

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedStorageInvoiceModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Insert Supplier Product Info
     * @param supplierProductInfoRequestDto 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public insertSupplierProductInfo(supplierProductInfoRequestDto: SupplierProductInfoRequestDto, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<StorageInvoiceModel>;
    public insertSupplierProductInfo(supplierProductInfoRequestDto: SupplierProductInfoRequestDto, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<StorageInvoiceModel>>;
    public insertSupplierProductInfo(supplierProductInfoRequestDto: SupplierProductInfoRequestDto, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<StorageInvoiceModel>>;
    public insertSupplierProductInfo(supplierProductInfoRequestDto: SupplierProductInfoRequestDto, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (supplierProductInfoRequestDto === null || supplierProductInfoRequestDto === undefined) {
            throw new Error('Required parameter supplierProductInfoRequestDto was null or undefined when calling insertSupplierProductInfo.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/app/suppliers`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<StorageInvoiceModel>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: supplierProductInfoRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Paid
     * @param storageInvoicePaidRequestDto 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public paidStorageInvoice(storageInvoicePaidRequestDto: StorageInvoicePaidRequestDto, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public paidStorageInvoice(storageInvoicePaidRequestDto: StorageInvoicePaidRequestDto, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public paidStorageInvoice(storageInvoicePaidRequestDto: StorageInvoicePaidRequestDto, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public paidStorageInvoice(storageInvoicePaidRequestDto: StorageInvoicePaidRequestDto, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (storageInvoicePaidRequestDto === null || storageInvoicePaidRequestDto === undefined) {
            throw new Error('Required parameter storageInvoicePaidRequestDto was null or undefined when calling paidStorageInvoice.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/paid`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: storageInvoicePaidRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Receive Storage Invoice
     * @param invoiceId 
     * @param storageInvoiceRequestDto 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public receiveStorageInvoice(invoiceId: number, storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public receiveStorageInvoice(invoiceId: number, storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public receiveStorageInvoice(invoiceId: number, storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public receiveStorageInvoice(invoiceId: number, storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling receiveStorageInvoice.');
        }
        if (storageInvoiceRequestDto === null || storageInvoiceRequestDto === undefined) {
            throw new Error('Required parameter storageInvoiceRequestDto was null or undefined when calling receiveStorageInvoice.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/${this.configuration.encodeParam({name: "invoiceId", value: invoiceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/received`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: storageInvoiceRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reject Storage Invoice
     * @param invoiceId 
     * @param jsonObject 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public rejectStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public rejectStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public rejectStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public rejectStorageInvoice(invoiceId: number, jsonObject: JsonObject, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (invoiceId === null || invoiceId === undefined) {
            throw new Error('Required parameter invoiceId was null or undefined when calling rejectStorageInvoice.');
        }
        if (jsonObject === null || jsonObject === undefined) {
            throw new Error('Required parameter jsonObject was null or undefined when calling rejectStorageInvoice.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices/${this.configuration.encodeParam({name: "invoiceId", value: invoiceId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/rejected`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jsonObject,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Save Storage Invoice
     * @param storageInvoiceRequestDto 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveStorageInvoice(storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JsonObject>;
    public saveStorageInvoice(storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JsonObject>>;
    public saveStorageInvoice(storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JsonObject>>;
    public saveStorageInvoice(storageInvoiceRequestDto: StorageInvoiceRequestDto, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (storageInvoiceRequestDto === null || storageInvoiceRequestDto === undefined) {
            throw new Error('Required parameter storageInvoiceRequestDto was null or undefined when calling saveStorageInvoice.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/storage-invoices`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<JsonObject>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: storageInvoiceRequestDto,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
